import { ReactElement } from "react";
import { useNavigate } from "react-router-dom";
import { Security } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl, OktaAuthOptions } from "@okta/okta-auth-js";

import { PATH_TO_LOGIN_CALLBACK } from "constants/navigation";
import { getEnvironmentName } from "lib/environment";
import getEnvVariables from "lib/environmentVariables/getEnvVariables";

const buildOktaAuth = () => {
  const envVariables = getEnvVariables();
  const config: OktaAuthOptions = {
    issuer: `${envVariables.oktaHostUrl}/oauth2/default`,
    clientId: envVariables.oktaAppClientId,
    redirectUri: `${window.location.origin}${PATH_TO_LOGIN_CALLBACK}`,
    scopes: ["openid", "sensitiveOperation"],
    tokenManager: {
      storage: "memory",
    },
  };

  if (getEnvironmentName() === "production") {
    // Step-up authentication
    config.acrValues = "urn:okta:loa:2fa:any";
  }

  return new OktaAuth(config);
};

const oktaAuth = buildOktaAuth();

const OktaSecurityProvider = ({
  children,
}: {
  children: ReactElement;
}): ReactElement => {
  const navigate = useNavigate();

  const restoreOriginalUri = async (
    _oktaAuth: OktaAuth,
    originalUri: string,
  ) => {
    navigate(toRelativeUrl(originalUri || "/", window.location.origin));
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  );
};

export default OktaSecurityProvider;
